<template>
    <div
        id="be-login"
        class="schermata-form pagina-vetrina"
    >
        <!--classe pagina-vetrina perchè deve esserci l'header delle pagine vetrina)-->
        <div class="body-wrapper">
            <gallery-header header='LOGIN' />

            <div class="clearfix" />

            <div class="d-flex justify-content-center align-items-center flex-wrap mx-auto py-4 px-2">
                <main class="w-100 p-0">
                    <div class="form-container bg-white rounded p-3">

                        <!--STEP 1-->
                        <transition name="slide">
                            <div
                                id="step-1"
                                class="step form-group mb-0"
                                v-show="isStep1"
                            >
                                <h1 class="mb-0 text-uppercase text-center">{{ $t("Richiesta di contatto/adesione per Rikorda Eventi") }}</h1>
                                <div class="mt-1 text-center">
                                    <span class="font-italic">Inserisci i tuoi dati per poter effettuare una richiesta di informazioni o di contatto o di adesione a Rikorda Eventi</span>
                                </div>

                                <validation-observer
                                    v-slot="{ handleSubmit }"
                                    tag="form"
                                    ref="contact-form-1"
                                    id="contactFormStep1"
                                >
                                    <fieldset class="mt-3">
                                        <div class="form-row">
                                            <div class="mb-3 col-sm-12">
                                                <label for="ragione-sociale">{{ $t("Ragione sociale") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        name="ragione-sociale"
                                                        id="ragione-sociale"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.ragioneSociale"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="col-sm-6 mb-3 form-group">
                                                <label for="email">{{ $t("Email") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required|validEmail"
                                                    mode="passive"
                                                    :debounce="5"
                                                    v-slot="{ errors, touched, valid, invalid, pending, validate }"
                                                    tag="div"
                                                >
                                                    <b-form-input
                                                        type="email"
                                                        name="email"
                                                        id="email"
                                                        ref="email"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.email"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                        @change="validate()"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{ $t(errors[0]) }}</span>
                                                </validation-provider>
                                            </div>

                                            <div class="col-sm-6 mb-3 form-group">
                                                <label for="piva">{{ $t("Partita IVA") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required|validVatOrTaxCode"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        name="piva"
                                                        id="piva"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.piva"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <div class="text-center">
                                        <button
                                            class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                            @click.prevent="handleSubmit(goToStep2)"
                                            :disabled="wizardBusy"
                                        >{{ $t('Continua') }}
                                            <font-awesome-icon
                                                class="ml-1"
                                                :icon="['fas', 'chevron-right']"
                                            />
                                        </button>
                                    </div>
                                </validation-observer>
                            </div>
                        </transition>
                        <!--/STEP 1-->

                        <!--STEP 2-->
                        <transition name="slide">
                            <div
                                id="step-2"
                                class="step form-group mb-0"
                                v-show="isStep2"
                            >
                                <h1 class="mb-0 text-uppercase text-center">{{ $t("Richiesta di contatto/adesione per Rikorda Eventi") }}</h1>
                                <div class="mt-1 text-center">
                                    <span class="font-italic">Inserisci i tuoi dati per poter effettuare una richiesta di informazioni o di contatto o di adesione a Rikorda Eventi</span>
                                </div>

                                <validation-observer
                                    v-slot="{ handleSubmit }"
                                    tag="form"
                                    ref="contact-form-1"
                                    id="contactFormStep1"
                                >
                                    <fieldset class="mt-3">
                                        <div class="form-row">
                                            <div class="col-sm-6 mb-3">
                                                <label for="province">{{$t('Provincia')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <select
                                                        name="province"
                                                        id="province"
                                                        ref="provincia"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.provincia"
                                                        @change="onChangeProvince"
                                                    >
                                                        <option value="">{{$t('Seleziona provincia')}}</option>
                                                        <option
                                                            v-for="province in provincesList"
                                                            v-bind:key="province.Sigla"
                                                            v-bind:value="province.Sigla"
                                                        >
                                                            {{province.Provincia}}
                                                        </option>
                                                    </select>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                            <div class="col-sm-6 mb-3">
                                                <label for="city">{{ $t("Città") }} <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <select
                                                        name="city"
                                                        id="city"
                                                        ref="citta"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.citta"
                                                        @change="onChangeCity"
                                                    >
                                                        <option
                                                            value=""
                                                            :selected="'sel'"
                                                        >{{$t('Seleziona città')}}
                                                        </option>
                                                        <option
                                                            v-for="(key, value) in citiesList"
                                                            v-bind:key="value"
                                                            v-bind:value="value"
                                                        >
                                                            {{value}}
                                                        </option>
                                                    </select>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-6 mb-3">
                                                <label for="zip">{{ $t("CAP") }} <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <select
                                                        name="zip"
                                                        id="zip"
                                                        ref="cap"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.cap"
                                                    >
                                                        <option value="">{{$t('Seleziona cap')}}</option>
                                                        <option
                                                            v-for="zip in zipList"
                                                            v-bind:key="zip.cap"
                                                            v-bind:value="zip.cap"
                                                        >
                                                            {{zip.cap}}
                                                        </option>
                                                    </select>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                            <div class="col-sm-6 mb-3 form-group">
                                                <label for="telefono">{{ $t("Telefono") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                >
                                                    <b-form-input
                                                        type="tel"
                                                        name="telefono"
                                                        id="telefono"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.telefono"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <label for="indirizzo">{{ $t("Indirizzo") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        name="indirizzo"
                                                        id="indirizzo"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.indirizzo"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <label for="messaggio">{{ $t("Messaggio") }}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ errors, touched, valid, invalid, pending }"
                                                >
                                                    <b-form-textarea
                                                        name="messaggio"
                                                        id="messaggio"
                                                        class="form-control rilievo-ombra-interna"
                                                        v-model="shop.messaggio"
                                                        :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                    ></b-form-textarea>
                                                    <span class="text-danger">{{errors[0]}}</span>
                                                </validation-provider>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <div class="text-center">
                                        <a
                                            role="button"
                                            class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                            @click.prevent="handleSubmit(goToStep3)"
                                        >{{ $t('Continua') }}
                                            <font-awesome-icon
                                                class="ml-1"
                                                :icon="['fas', 'chevron-right']"
                                            />
                                        </a>
                                    </div>
                                </validation-observer>
                            </div>
                        </transition>
                        <!--/STEP 2-->

                        <!--STEP 3-->
                        <transition name="slide">
                            <div
                                id="step-3"
                                class="step form-group mb-0"
                                v-show="isStep3"
                            >
                                <h1 class="mb-0 text-uppercase text-center">{{ $t("Grazie per aver completato la richiesta di contatto") }}</h1>
                                <div class="mt-1">
                                    La tua richiesta di contatto è stata spedita via email a:
                                </div>
                                <div class="mt-1 text-center">
                                    <h6>{{ recipient.name }}</h6>
                                </div>
                                <div class="mt-1">
                                    al seguente indirizzo email:
                                </div>
                                <div class="mt-1 text-center">
                                    <h6>{{ recipient.email }}</h6>
                                </div>
                                <div class="mt-3">
                                    Una copia è stata inviata anche a te.
                                </div>
                                <div class="mt-1">
                                    Ti ringraziamo per l'attenzione e ti auguriamo buonissimi eventi!!!
                                </div>
                                <div
                                    v-if="shopExists"
                                    class="mt-3 font-titoli-rikorda"
                                >
                                    <div class="mt-1">
                                        Ti ricordiamo che sei già registrato su Rikorda e puoi già accedere inserendo la tua username
                                        (XRF.......) e password da fotografo.
                                    </div>
                                    <div class="mt-1">Se non ti ricordi la password basta che clicchi su "Password Dimenticata?"</div>
                                    <div class="mt-1">
                                        <router-link :to="{ name: 'backend' }">Clicca qui</router-link> per andare su Accedi.
                                    </div>
                                </div>
                                <div class="mt-1 text-center">
                                    <router-link
                                        :to="{ name: 'home' }"
                                        class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                        @click.prevent="handleSubmit(goToStep3)"
                                    >{{ $t('Vai alla Home') }}
                                    </router-link>
                                </div>
                            </div>
                        </transition>
                        <!--/STEP 3-->
                    </div>
                </main>

            </div>

            <gallery-footer :showRikorda='true' />
        </div>

    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import GalleryHeader from "../components/gallery/Header";
import GalleryFooter from "../components/gallery/Footer";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Questo campo è obbligatorio"
});

export default {
    name: "ContactRequest",

    components: {
        ValidationProvider,
        ValidationObserver,
        GalleryHeader,
        GalleryFooter
    },

    data() {
        return {
            wizardStep: 1,
            wizardBusy: false,
            idUtente: null,
            shop: {
                ragioneSociale: null,
                email: null,
                piva: null,
                provincia: null,
                cap: null,
                citta: null,
                telefono: null,
                indirizzo: null,
                messaggio: null
            },
            shopData: null,
            shopExists: false,
            provincesList: [],
            zipList: [],
            citiesList: [],
            recipient: {
                name: null,
                email: null
            }
        };
    },

    methods: {
        goToStep2() {
            this.wizardBusy = true;
            this.$api
                .backendContactCheckPiva(this.shop.piva)
                .then((response) => {
                    console.log("BACKEND_CONTACT_CHECK_PIVA", response);
                    if (response.shopData) {
                        this.wizardStep = 2;
                        this.idUtente = response.shopData.idUtente || null;
                        this.shop.provincia = response.shopData.provincia || "";
                        this.shop.citta = response.shopData.citta || "";
                        this.shop.cap = response.shopData.cap || "";
                        this.shop.telefono = response.shopData.telefono || "";
                        this.shop.indirizzo = response.shopData.indirizzo || "";
                    }
                    this.shopExists = this.idUtente != null;
                    this.provincesList = response.provinces.provinces;

                    this.onChangeProvince();
                })
                .catch((error) => {
                    console.error("BACKEND_CONTACT_CHECK_PIVA", error);
                })
                .finally(() => {
                    this.wizardBusy = false;
                });
        },

        goToStep3() {
            if (this.$gtm) {
                this.$gtm.push({ event: "generate_lead" });
            }

            this.$api
                .backendContactRequest(this.idUtente, this.shop)
                .then((response) => {
                    console.log("BACKEND_CONTACT_REQUEST", response);
                    this.recipient = response.recipient;
                })
                .catch((error) => {
                    console.error("BACKEND_CONTACT_REQUEST", error);
                });
            this.wizardStep = 3;
        },

        onChangeProvince() {
            this.$refs.provincia.disabled = true;
            this.$refs.citta.disabled = true;
            this.$refs.cap.disabled = true;
            this.$api
                .getItalyCities(this.shop.provincia)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.citiesList = result.cities;
                    Object.keys(this.citiesList).every((key, index) => {
                        if (
                            key.toLowerCase() === this.shop.citta.toLowerCase()
                        ) {
                            this.shop.citta = key;
                            return false;
                        }
                        return true;
                    });

                    if (!this.citiesList || !this.citiesList[this.shop.citta]) {
                        this.shop.citta = "";
                    }

                    this.onChangeCity();
                    this.$refs.provincia.disabled = false;
                    this.$refs.citta.disabled = false;
                    this.$refs.cap.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                });
        },

        onChangeCity() {
            if (this.citiesList[this.shop.citta]) {
                this.zipList = this.citiesList[this.shop.citta];
                if (
                    this.zipList.filter((zip) => {
                        return zip.cap === this.shop.cap;
                    }).length === 0
                ) {
                    this.shop.cap = "";
                }
            } else {
                this.zipList = [];
                this.shop.cap = "";
            }
        }
    },

    computed: {
        isStep1() {
            return this.wizardStep == 1;
        },
        isStep2() {
            return this.wizardStep == 2;
        },
        isStep3() {
            return this.wizardStep == 3;
        }
    }
};
</script>

<style>
.schermata-form .body-wrapper > div:not(.clearfix) {
    margin-top: calc(2rem + 96px);
}
</style>
